import axios from 'axios';
import { normalize, schema } from 'normalizr';

import config from '../utils/config';
import * as MapFieldListActions from '../actions/mapFieldList';
import * as AuthCreators from './auth';


const URL = config().mapFieldList;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const fetchMapFieldList = (id: string): any => {
  return (dispatch): void => {
    dispatch(MapFieldListActions.setMapFieldListPending());
    const params = new URLSearchParams();

    params.append('customer_id', id);

    axios({
      method: 'get',
      url: `${URL}?${params}`,
    })
      .then(response => {
        const fieldListSchema = new schema.Entity('fieldList');
        const normalizedData = normalize(response.data.data.results, [fieldListSchema]);

        dispatch(MapFieldListActions.fetchMapFieldListSuccess(normalizedData.entities.fieldList));
        dispatch(MapFieldListActions.fetchMapFieldListOrder(normalizedData.result));
        dispatch(MapFieldListActions.setCurrentDrawLayer(response.data.data.results[0].geometry.coordinates));
        dispatch(MapFieldListActions.setCurrentCenter(response.data.data.results[0].properties.center.coordinates));
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch(AuthCreators.fetchRefreshAuthToken(fetchMapFieldList(id)));
        } else {
          dispatch(MapFieldListActions.setMapFieldListError());
        }
      });
  };
};
